// extracted by mini-css-extract-plugin
export default {"tooltip":"Ln-z","sharingV2":"Mn-z","sharingIconsV2":"Nn-z","links":"On-z","link":"Pn-z","facebookV2":"Qn-z","twitterV2":"Rn-z","pinterestV2":"Sn-z"};